import { includes } from 'lodash'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { PATH as PATH_AUTH } from 'src/pages/auth'

type Props = {
  listText: string[]
  textColorId?: number
}
const DescriptionHint = (props: Props) => {
  const { listText, textColorId } = props
  const navigate = useNavigate()
  const handleNavigate = (path: string) => {
    navigate(path)
  }
  return (
    <Description>
      {listText.map((t, index) => {
        const isColor = textColorId === index
        if (t === '<br />') {
          return <br key={index} />
        }
        if (includes(t, '@')) {
          return (
            <div key={index}>
              Mail:{' '}
              <a href={`mailto:${t}`} className="link-mail">
                {t}
              </a>
            </div>
          )
        }
        if (
          t.includes('マイページより別の診療科目のプランをご検討ください。')
        ) {
          return (
            <p
              key={index}
              className={`hint-text ${
                isColor ? 'cl-primary font-weight-bold' : ''
              }`}
            >
              <a
                className="link-page"
                onClick={() => handleNavigate(PATH_AUTH.MEDICAL_SPECIALTY)}
              >
                マイページ
              </a>
              より別の診療科目のプランをご検討ください。
            </p>
          )
        }
        return (
          <p
            key={index}
            className={`hint-text ${
              isColor ? 'cl-primary font-weight-bold' : ''
            }`}
          >
            {t}
          </p>
        )
      })}
    </Description>
  )
}

const Description = styled.div`
  padding: 20px;
  background-color: #f1efe7;

  .hint-text {
    font-weight: 500;
    font-size: 13px;
    line-height: 24px;
    color: #000000;
    margin-bottom: 0;
  }

  .link-page {
    color: #006597;
    text-decoration: underline;
  }

  .link-mail:hover {
    color: #006597;
    text-decoration: underline;
  }
`

export default DescriptionHint
